<template>
    <div>
        <card-header title="Media Library" icon="fa-photo-film-music"/>

        <card-body class="is-flex">
            <Browser />
        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http, axiosInstance, apiUrl} from "@/http_client";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import SearchListItem from "../../TIER/components/SearchListItem";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardContainer from "../../TIER/components/CardContainer";

    import Browser from "./Browser";

    export default {
        components: {CardHeader, CardBody, Browser}
    };
</script>

<style lang="scss" scoped>

</style>
